import ApolloClient from './apolloClient'
import Attachment from './attachment'
import Auth from './auth'
import Event from './event'
import Form from './form'
import GraphQL from './graphQL'
import Regex from './regex'

const Utils = {
  Form,
  GraphQL,
  Event,
  Regex,
  ApolloClient,
  Auth,
  Attachment,
}
export default Utils
